import MapWorkspace from './component';

export default MapWorkspace;
